import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'

import values from 'lodash/values'
import forEach from 'lodash/forEach'
import filter from 'lodash/filter'
import get from 'lodash/get'

import theme from '../../styles/theme'

import Trending from '../Trending'
import InstagramCarousel from '../InstagramCarousel'
import Newsletter from '../Newsletter/Newsletter'
import ArticlesRow from './ArticlesRow'
import LookbookRow from './LookbookRow'
import LandingPageTitle from '../Widgets/LandingPageTitle'
import LoadMoreArticlesButton from '../LoadMoreArticlesButton'

import {TodayStructuredDataComponent, ArticleListStructuredDataComponent} from '../StructuredDataComponent'
import TopPicksSlice from './TopPicksSlice'
import HeroGrid from './HeroGrid'
import HeroFeature from './HeroFeature'
import ArticleListing from './ArticleListing'

const slice_components = {
    'hero_grid': (props) => <HeroGrid {...props} />,
    'hero_feature': (props) => <HeroFeature {...props} />,
    'article_type': ({ slice, ...props }) => slice.landing_page_uid === 'lookbooks' ?
        <LookbookRow {...props} slice={slice} /> :
        <ArticlesRow {...props} slice={slice} color={theme.getLandingPageColor(slice.landing_page_uid)} />,
    'article_listing': ({page, slice, ...props}) => (
      <ArticleListing
        {...props}
        page={page}
        columns={slice.number_of_articles_per_row}
        articles={slice.articles}
        variation={page.slug === 'lookbooks' ? 'vertical' : undefined}
        background_contrast={slice.background_contrast}
        show_article_summaries={slice.show_article_summaries}
        carousel_on_mobile={slice.carousel_on_mobile}
      />
    ),
    'trending_slice': (props) => <Trending {...props} />,
    'newsletter': (props) => <Newsletter {...props} />,
    'instagram_slice': ({slice, ...props}) => <InstagramCarousel {...props} slice={slice} />,
    'top_picks_slice': ({ key, ...props }) => <TopPicksSlice {...props} key={key} id={`today-${key}`} />,
}

class LandingPage extends PureComponent {
  render() {
    const { page } = this.props;
    const { slug, slices, title, summary } = page;

    if(!slices) return null
      
    var dataStructure = [];

    forEach(slices, slice => {
      switch(slice.type) {
        case 'hero_grid':
          dataStructure = [...dataStructure, ...filter(values(slice), item => item.id)]
          break;
        case 'article_type':
          dataStructure = dataStructure = [...dataStructure, ...get(slice, ['results'], [])]
          break;
        case 'article_listing':
          dataStructure = dataStructure = [...dataStructure, ...get(slice, ['articles'], [])]
          break;
        // no default
      }
    })

    const items = slices.map((slice, i) => slice_components[slice.type] && slice_components[slice.type]({ page, slice, key: i }))

    return (
      <React.Fragment>
        <TodayStructuredDataComponent />
        <ArticleListStructuredDataComponent articles={dataStructure} />
        {slug !== 'today' && <LandingPageTitle title={title} summary={summary} />}
        <div key={this.props.page}>
            {items}
        </div>
        <LoadMoreArticlesButton />
      </React.Fragment>
    )
  }
}


export default injectSheet({
  flushLastChild: {
    '& section:last-child': {
      marginBottom: 0
    }
  }
})(LandingPage);



// WEBPACK FOOTER //
// ./src/components/LandingPage/index.js